var SELF = '_self';

export var launchUri = function (url) {
  return window.open(url, SELF);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/amazon-cognito-auth-js/es/UriHelper.js
// module id = 1601
// module chunks = 115